import { FlowCardLoading } from '@components/FlowCard'
import { SignInVerifyPin } from '@components/RouteComponents'
import { orgDetailsQueryOptions } from '@src/queryOptions/org'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/phone/signInVerifyPin')({
  loader: async ({ context: { queryClient, store } }) => {
    const storeState = store.getState().onboarding
    return queryClient.ensureQueryData(
      orgDetailsQueryOptions({ organizationId: storeState.orgId })
    )
  },
  pendingComponent: FlowCardLoading,
  component: SignInVerifyPin,
})
